import React from 'react';

export const withGroup = <C extends React.FC<{}>, Group>(component: C, group: Group) => {
  Object.assign(component,group)
  return component as C & Group;
};
